import React from 'react';
import {Button, Tooltip, classify} from '@spaced-out/ui-design-system';
import css from './minimized-chat-button.css';


export type MinimizedChatButtonVariant = 'primary' | 'secondary';

interface MinimizedChatButtonProps {
  variant?: MinimizedChatButtonVariant;
  tooltipTitle: string;
  ariaLabel: string;
  onClick: () => void;
}

export function MinimizedChatButton({
  variant = 'secondary',
  tooltipTitle,
  ariaLabel,
  onClick,
}: MinimizedChatButtonProps) {
  return (
    <Tooltip
      title={tooltipTitle}
      placement="right"
      delayMotionDuration="slowest"
    >
      <Button
        iconRightName="sparkles"
        type="secondary"
        iconRightType="solid"
        classNames={{
          wrapper: classify(css.minimizedButton, {
            [css.primary]: variant === 'primary',
            [css.secondary]: variant === 'secondary',
          }),
          icon: classify(css.minimizedButtonIcon, {
            [css.primaryIcon]: variant === 'primary',
            [css.secondaryIcon]: variant === 'secondary',
          }),
        }}
        onClick={onClick}
        aria-label={ariaLabel}
      />
    </Tooltip>
  );
}
